import FloatingLabelMaskedInput from './FloatingLabelMaskedInput';

export default FloatingLabelMaskedInput;



// WEBPACK FOOTER //
// ./src/components/common/FloatingLabelMaskedInput/index.js